import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const HistorialTrasladosApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTraslados = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("prod_bodega_control_calidad", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTraslados,

        cargando,
    };
};
